export default __webpack_public_path__ + "static/media/vip-exclusive.66951ea0.svg";